import { PROPERTY_DATA_FILTER_KEYS } from '@/constants';
import { applyComplaintsSingleParamChange } from './complaints-filter-change-handler';
import { applyViolationsSingleParamChange } from './violations-filter-change-handler';

const groupNameToParamChangeHandler = {
  [PROPERTY_DATA_FILTER_KEYS.complaints]: applyComplaintsSingleParamChange,
  [PROPERTY_DATA_FILTER_KEYS.violations]: applyViolationsSingleParamChange,
};

function applyDefaultSingleParamChange(
  mapFilterParams,
  groupName,
  type,
  value
) {
  return mapFilterParams.setIn([groupName, type], value);
}

export function applySingleFilterParamChange(
  mapFilterParams,
  groupName,
  type,
  value
) {
  const applyGroupSpecificSingleParamChange =
    groupNameToParamChangeHandler[groupName];

  if (!applyGroupSpecificSingleParamChange) {
    return applyDefaultSingleParamChange(
      mapFilterParams,
      groupName,
      type,
      value
    );
  }

  return applyGroupSpecificSingleParamChange(
    mapFilterParams,
    groupName,
    type,
    value
  );
}
